import React from 'react';
import './image-cache.scss';
/*
	Pass in one or more image paths from src/assets/images to get
	them into the browser cache so they are ready before
	they are needed.
 */
export function ImageCache({ images }) {
  return (
    <div className="image-cache">
      {images.map((image, index) => (
        <img key={`cached-image_${index}`} src={image} />
      ))}
    </div>
  );
}
